import { Navigate, useLocation } from "@solidjs/router";

const NavigateToTracklist = () => {
	const location = useLocation();
	return <Navigate href={location.pathname.replace("/t/", "/tracklist/")} state={location.state} />;
};
export default NavigateToTracklist;
